import { render, staticRenderFns } from "./SoftwareAssessment.vue?vue&type=template&id=7174f806&scoped=true"
import script from "./SoftwareAssessment.vue?vue&type=script&lang=js"
export * from "./SoftwareAssessment.vue?vue&type=script&lang=js"
import style0 from "./SoftwareAssessment.vue?vue&type=style&index=0&id=7174f806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7174f806",
  null
  
)

export default component.exports